import Vue from 'vue'

import baseStore from '~/baseStore'
import API_company from './API/company'
import API_booth from './API/booth'
import API_user from './API/user'
import API_index from './API/index'
import baseConsole from '~bac/store'
import API_position from './API/position'
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {

    },
    mutations: {

    },
    actions: {

    },

    modules: { baseStore, API_company, API_booth, API_user, API_index,API_position, baseConsole }
})

export default store
